import { resolveScope, scopeAccountIds, type Scope } from "./scope";
import { useAccounts, useSavedScopes } from "./use-mail-context";

/**
 * The scope a URL's `scope` names and the accounts it covers, for the inbox and the sidebar's
 * counts (WP-064). `scope` undefined: a saved scope while saved scopes load; null: no such saved
 * scope. `ids` null: every account; undefined: not known yet (a workspace waits for the accounts).
 */
export function useScope(workspaceId: string, param: string | undefined) {
  const accounts = useAccounts();
  const saved = useSavedScopes();
  const scope: Scope | null | undefined =
    saved === null && param?.startsWith("saved:") === true ? undefined : resolveScope(param, workspaceId, saved === null ? [] : saved);
  const ids =
    scope === null || scope === undefined
      ? undefined
      : scope.kind === "workspaces" && accounts.data === undefined
        ? undefined
        : scopeAccountIds(scope, accounts.data === undefined ? [] : accounts.data);
  return { scope, ids, saved, accounts };
}
